<template>
  <el-dialog
    title="添加模板"
    :visible="dialogVisible"
    :before-close="beforeClose"
    width="70%"
    append-to-body
  >
    <el-form
      ref="form"
      :model="tempValue"
      label-width="80px"
      :rules="rules"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="模板编号" prop="template_no">
            <eco-input v-model="tempValue.template_no" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="事项" prop="matter">
            <el-select filterable v-model="tempValue.matter" :disabled="true">
              <el-option
                v-for="item in boDefIdList"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="模板内容" prop="content">
        <vue-tinymce-wrap v-model="tempValue.content"></vue-tinymce-wrap>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="编制人">
            <el-input
              v-model="tempValue.create_user"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编制时间">
            <el-input
              v-model="tempValue.create_time"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="submit('form')"
        type="primary"
        :loading="tempAddLoading"
        >确定</el-button
      >
      <el-button @click="beforeClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import form from "@/api/form.js";
import req from "@/request";
import utils from "@/utils";
import { mapState } from "vuex";
export default {
  name: "tempAdd",
  props: {
    selectModel: String,
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      tempValue: {
        template_no: "",
        matter: "",
        create_user: "",
        content: "",
        create_time: ""
      },
      boDefIdList: [],
      tempAddLoading: false,
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        matter: [{ required: true, message: "请选择事项", trigger: "blur" }]
      },
      selectUploadId: "",
      importurlWl:
        req.getContext().manage +
        req.getContext().portal +
        "/system/file/v1/upload"
    };
  },
  watch: {
    dialogVisible: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getDetail();
        }
      }
    }
  },
  computed: {
    ...mapState({
      allDataDict: state => state.user.allDataDict,
      allEnumerate: state => state.user.allEnumerate
    })
  },
  mounted() {
    this.boDefIdList = utils.findDictList("sx", this.allDataDict);
  },
  methods: {
    getDetail() {
      let params = Object.assign(
        {},
        {
          id: this.selectModel
        }
      );
      form.getOaContractTemplateById(params).then(res => {
        this.tempValue = Object.assign({}, res);
      });
    },
    beforeClose() {
      this.$refs["form"].resetFields();
      this.$emit("beforeClose");
      this.tempValue = {
        template_no: "",
        matter: "",
        create_user: "",
        content: "",
        create_time: ""
      };
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        this.tempAddLoading = true;
        if (valid) {
          let params = Object.assign({}, this.tempValue);
          form
            .updateOaContractTemplate(params)
            .then(() => {
              this.tempAddLoading = false;
              this.beforeClose();
            })
            .catch(() => {
              this.tempAddLoading = false;
            });
        } else {
          this.tempAddLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
